module.exports = __webpack_public_path__ + "static/img/mxyyh5.bbe65e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mxyyh5.png
// module id = wPeC
// module chunks = 0